module.exports = __webpack_public_path__ + "static/media/xray-training-kneecap-view1.14cadd50.png";